<template>
  <div class="aboutsxsxsx">
    
    <el-row :gutter="20">
      <el-col :span="14">
        <div class="grid-content bg-purple box_top"  style="height: 450px;">
          <div style="height: 60px;padding-top: 20px;">
            <span style="margin-left: 20px;font-size: 18px;font-weight: 700;">学生危机变化走势</span>
            <el-button type="primary" style="float: right;margin-right: 20px;"  size="mini">查看</el-button>
            <el-date-picker size="small"  style="float: right;margin-right: 20px;" v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期"> </el-date-picker>
            <div ref="myechart" style="width: calc(100% - 50px);height:300px;margin-top: 40px;"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="10" style="background-color: #fff;height: 450px;">
        <div class="grid-content bg-purple">
          <span style="margin-left: 20px;font-weight: 700;font-size: 18px;display: inline-block;margin-top: 20px;">学生今日危机播报</span>
          <div ref="myechart2" class="ujhj"  style="width: 400px;float: left;height:400px; margin: auto;"></div>
        </div>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple" style="height: 500px;background-color: #fff;margin-top: 10px;">
          <el-form   :inline="true" class="demo-form-inline" style="margin-left: 20px;padding-top: 20px;">
            <el-form-item label="统计时间">
              <el-date-picker  size="small" v-model="form.date1" type="date"  placeholder="选择日期"> </el-date-picker>
            </el-form-item>
            <el-form-item label="学位">
              <el-select v-model="form.region" size="small" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="危机状态">
              <el-select v-model="form.region" size="small" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="年级">
              <el-select v-model="form.region" size="small" placeholder="请选择活动区域">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small">查看</el-button>
              <!-- <el-button size="small" type="primary" style="float: right;margin-right: 20px;">查看</el-button> -->
            </el-form-item>
          </el-form>
          <el-row>
            <el-col :span="9">
              <div class="grid-content bg-purple ">
                <div ref="myechart3"  style="width: 400px;height:400px;margin: auto;"></div>
              </div>
            </el-col>
            <el-col :span="15">
              <div class="grid-content bg-purple">
                <ul class="zhongul">
                  <li v-for="item in datalist[0]" :key='item.index'>
                    <span> {{item.tit}} </span>
                    <el-progress :percentage="item.val / 360 * 100" :format="format" ></el-progress>
                    <i>{{item.val}}</i>
                  </li>
                </ul>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <el-row style="margin-top: 10px;background-color: #fff;height: 400px;">
      <el-col :span="14" >
        <div class="grid-content bg-purple">
            <ul class="box_ul">
              <li>
                <p @click="switchmb(1)">学习困扰<i>285(25%)</i></p>
                <ul v-if="swts == 1">
                  <li v-for="item in datalist[0]" :key='item.index'>
                    <span>{{item.tit}}</span>
                    <el-progress :percentage="item.val / 360 * 100" :format="format" ></el-progress>
                    <i>{{item.val}}</i>
                  </li>
                </ul>
              </li>
              <li>
                <p @click="switchmb(2)">生活困扰<i>285(25%)</i></p>
                <ul v-if="swts == 2">
                  <li v-for="item in datalist[1]" :key='item.index'>
                    <span> {{item.tit}} </span>
                    <el-progress :percentage="item.val / 1665 * 100" :format="format"></el-progress>
                    <i>{{item.val}}</i>
                  </li>
                </ul>
              </li>
              <li>
                <p @click="switchmb(3)">交往困扰<i>285(25%)</i></p>
                <ul v-if="swts == 3">
                  <li v-for="item in datalist[2]" :key='item.index'>
                    <span> {{item.tit}}</span>
                    <el-progress :percentage="item.val / 99 * 100" :format="format"></el-progress>
                    <i>{{item.val}}</i>
                  </li>
                </ul>
              </li>
              <li>
                <p @click="switchmb(4)">发展困扰<i>285(25%)</i></p>
                <ul v-if="swts == 4">
                  <li v-for="item in datalist[3]" :key='item.index'>
                    <span> {{item.tit}}</span>
                    <el-progress :percentage="item.val / 2342 * 100" :format="format"></el-progress>
                    <i>{{item.val}}</i>
                  </li>
                </ul>
              </li>
              <li>
                <p @click="switchmb(5)">心理困扰<i>285(25%)</i></p>
                <ul v-if="swts == 5">
                  <li v-for="item in datalist[4]" :key='item.index'>
                    <span> {{item.tit}}</span>
                    <el-progress :percentage="item.val / 4512 * 100" :format="format"></el-progress>
                    <i>{{item.val}}</i>
                  </li>
                </ul>
              </li>
            </ul>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="grid-content bg-purple to_box" style="background-color: aqua;">
          <ul style="width: 100%;">
            <li style="margin-top:10px;font-size: 16px;font-weight: 600;padding-bottom: 10px;">发现途径</li>
            <li style="width: 100%;">
              <ul style="width: 100%;">
                <li v-for="item in datalist2[0]" :key='item.index'>
                  <span> {{item.tit}} </span>
                  <el-progress :percentage="item.val / 360 * 100" :format="format"></el-progress>
                  <i>{{item.val}}</i>
                </li>
                <li style="margin-top:10px;font-size: 16px;font-weight: 600;width: 93%;padding-bottom: 10px;">危机类型</li>
              </ul>
            </li>
            <li style="width: 100%;">
              <ul style="width: 100%;">
                <li v-for="item in datalist2[1]" :key='item.index'>
                  <span> {{item.tit}} </span>
                  <el-progress :percentage="item.val / 360 * 100" :format="format"></el-progress>
                  <i>{{item.val}}</i>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data(){
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      value1:'',
      swts:1,
      datalist:[[
        {val:360,tit:"学业基础薄弱"},
        {val:120,tit:"学习能力差"},
        {val:289,tit:"科研能力差"},
        {val:214,tit:"缺乏专业兴趣"},
        {val:165,tit:"第一次挂科"},
        {val:99,tit:"多门挂科"},
        {val:45,tit:"缺课缺考"},
        {val:163,tit:"留级延期"},
        {val:180,tit:"其他"},
      ],[
        {val:1360,tit:"经济困难"},
        {val:1220,tit:"未获助学贷款"},
        {val:289,tit:"家庭重大变故"},
        {val:454,tit:"严重躯体疾病"},
        {val:1665,tit:"生活自理困难"},
        {val:699,tit:"身体缺陷"},
        {val:445,tit:"语言困难"},
        {val:763,tit:"被骗被控制"},
        {val:666,tit:"其他"},
      ],[
        {val:12,tit:"内向孤僻"},
        {val:33,tit:"退缩回避"},
        {val:44,tit:"适应不良"},
        {val:55,tit:"同学关系不良"},
        {val:66,tit:"师生关系不良"},
        {val:99,tit:"亲密关系不良"},
        {val:45,tit:"家庭关系不良"},
        {val:77,tit:"遭遇欺凌等"},
        {val:88,tit:"其他"},
      ],[
        {val:1234,tit:"深感自卑"},
        {val:1345,tit:"思想偏激"},
        {val:2342,tit:"发展迷茫"},
        {val:1234,tit:"过高期待"},
        {val:1232,tit:"毕业困难"},
        {val:1211,tit:"考研失败"},
        {val:485,tit:"就业困难"},
        {val:876,tit:"创业失败"},
        {val:567,tit:"其他"},
      ],[
        {val:4512,tit:"自杀伤人倾向"},
        {val:2123,tit:"重性精神病"},
        {val:3289,tit:"应激危机"},
        {val:2214,tit:"人格问题"},
        {val:1615,tit:"情绪障碍"},
        {val:1199,tit:"成瘾行为"},
        {val:1845,tit:"进食问题"},
        {val:1963,tit:"睡眠问题"},
        {val:2180,tit:"其他"},
      ]],
      datalist2:[[
        {val:360,tit:"学生本人"},
        {val:120,tit:"家人配偶"},
        {val:289,tit:"其他亲属"},
        {val:214,tit:"同学"},
        {val:165,tit:"朋友"},
        {val:165,tit:"心理中心"},
        {val:165,tit:"授课教师"},
        {val:165,tit:"导师"},
        {val:165,tit:"其他校内成员"},
        {val:165,tit:"其他校外成员"},
        {val:165,tit:"心理委员"},
        {val:165,tit:"心理联络员"},
        {val:165,tit:"心理辅导员"},
        {val:165,tit:"辅导员"},
        {val:165,tit:"班主任"},
        {val:165,tit:"微信微博QQ"},
        {val:165,tit:"电话短信邮件"},
        {val:165,tit:"书面"},
        {val:165,tit:"当面交流"},
        {val:165,tit:"其他"},
      ],[
        {val:1360,tit:"自杀想法"},
        {val:1220,tit:"自杀计划"},
        {val:289,tit:"自杀未遂"},
        {val:454,tit:"自杀实施中"},
        {val:1665,tit:"自杀姿态"},
        {val:1665,tit:"被动自杀"},
        {val:1665,tit:"自伤自残"},
        {val:1665,tit:"伤害他人"},
        {val:1665,tit:"扩大性自杀"},
        {val:1665,tit:"疑似重性精神病"},
      ]]
    }
  },
  methods:{
    switchmb(val){
      this.swts = val;
    },
    format(percentage) {

    },
    setChart() {
      var myChart = this.$echarts.init(this.$refs.myechart); // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['红色预警人数', '橙色预警人数', '黄色预警人数', '危机上报人数', '危机干预人数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '红色预警人数',
            type: 'line',
            data: [21, 11, 12, 55, 43, 24, 42],
          },
          {
            name: '橙色预警人数',
            type: 'line',
            data: [23, 74, 58, 74, 67, 82, 28],
          },
          {
            name: '黄色预警人数',
            type: 'line',
            data: [57, 12, 24, 82, 35, 74, 23],
          },{
            name: '危机上报人数',
            type: 'line',
            data: [25, 23, 44, 15, 75, 85, 41],
          },{
            name: '危机干预人数',
            type: 'line',
            data: [15, 55, 72, 63, 51, 75, 15],
          }

        ]
      };
      myChart.setOption(option);
    },

    setChart2() {
      var myChart2 = this.$echarts.init(this.$refs.myechart2); // 指定图表的配置项和数据
      var option = {
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: '标题',
              type: 'pie',
              radius: ['40%', '70%'],
              data: [
                { value: 1048, name: '物理学院' },
                { value: 735, name: '化学学院' },
                { value: 580, name: '光华学院' },
                { value: 484, name: '数学学院' },
                { value: 11, name: '音乐学院' },
                { value: 300, name: '心理学院' }
              ]
            }
          ]
        }
      //使用刚指定的配置项和数据显示图表。
      myChart2.setOption(option);
    },
    setChart3() {
      var myChart3 = this.$echarts.init(this.$refs.myechart3); // 指定图表的配置项和数据
      var option = {
          tooltip: {
            trigger: 'item'
          },
          series: [
            {
              name: '标题',
              type: 'pie',
              radius: ['40%', '70%'],
              data: [
                { value: 1048, name: '物理学院' },
                { value: 735, name: '化学学院' },
                { value: 580, name: '光华学院' },
                { value: 484, name: '数学学院' },
                { value: 11, name: '音乐学院' },
                { value: 300, name: '心理学院' }
              ]
            }
          ]
        }
      //使用刚指定的配置项和数据显示图表。
      myChart3.setOption(option);
    },

  },
  mounted(){
    this.setChart();
    this.setChart2();
    this.setChart3();
  },
}
</script>

<style>

.box_top{width: 100%;height: 400px;float: left;background-color: #fff;}

.box_top2{height: 400px;float: left;background-color: #fff;width: calc(100% - 952px);float: right;background-color: #fff;}

.box_ul{width: 100%;position: relative;}

.box_ul li{width: 100%;}

.box_ul li p{width: 100px;height: 60px;background-color: #ff6215;margin-top: 10px;text-align: center;line-height: 20px;margin-left: 20px;}
 
.box_ul li ul{position: absolute;top: 0px;left: 150px;width: 100%;}

.box_ul li ul li i{position: absolute;right: 20px;}

.box_ul li li{position: relative;height: 40px;width: calc(100% - 150px);}

.box_ul li span{position: absolute;top: 0px;left: 0px;width: 100px;text-align: right;}

.box_ul  .el-progress{position: absolute;left: 120px;}

.box_ul .el-progress-bar__inner{height: 20px;border-radius:0px;background: linear-gradient(90deg, rgba(20, 132, 244, 1) 0%, rgba(156, 203, 248, 1) 100%);}

.to_box .el-progress-bar__inner{height: 20px;border-radius:0px;background: linear-gradient(90deg, rgba(20, 132, 244, 1) 0%, rgba(156, 203, 248, 1) 100%);}

.to_box .el-progress-bar__outer{border-radius:0px;height: 12px !important;}

.box_ul .el-progress-bar{width: 520px;}

.box_ul .el-progress-bar__outer{border-radius:0px;height: 12px !important;}

.to_box li{width: 20%;float: left;}

.box2 {width: calc(100% - 652px);height: 600px;background-color: #ffffff;float: right;border-left: 1px solid #ff6215;}

.box2 ul li li {float: left;width: 16%;margin-left: 3%;margin-top: 20px;}

.box_top2_ul li{margin-top: 10px;}

.box2 .el-progress-bar__outer{height: 12px !important;margin-top: 4px;border-radius: 0px;}

.box2 .el-progress-bar__inner{border-radius: 0px;background: linear-gradient(90deg, rgba(20, 132, 244, 1) 0%, rgba(156, 203, 248, 1) 100%);}

.zhongul li{width: 400px;height: 60px;float: left;}

.zhongul{margin-top: 40px;}

.zhongul  .el-progress-bar__outer{border-radius:0px;height: 12px !important;}

.zhongul .el-progress-bar__inner{border-radius: 0px !important;background: linear-gradient(90deg, rgba(20, 132, 244, 1) 0%, rgba(156, 203, 248, 1) 100%);}

.ujhj{float: none !important;}

</style>
